module.exports = __webpack_public_path__ + "img/223.1ffe279d.jpg";